module.exports = __webpack_public_path__ + "media/mobi-white-3gRura7.mp3";